import { ReactNode, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function Navbar({ children }: { children: ReactNode }) {
  const navbarRef = useRef<HTMLElement>(null);

  const { pathname } = useLocation();

  // Get first path segment (ignores leading `/`)
  const topLevel = pathname.split("/")[1] || "home";
  const pageRouteName = topLevel === "simple-payment" ? "payment" : topLevel;

  // Format it: capitalize first letters and replace hyphens
  const pageTitle = pageRouteName
    .replace(/-/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());

  useEffect(() => {
    const handleScroll = () => {
      const el = navbarRef.current;
      if (!el) return;

      if (window.scrollY > 10) {
        el.classList.add("shadow-md");
        el.classList.remove("shadow-none");
        el.classList.add("bg-[#EAECF0]");
      } else {
        el.classList.add("shadow-none");
        el.classList.remove("shadow-md");
        el.classList.remove("bg-[#EAECF0]");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className="fixed left-0 right-0 top-0 ml-[264px] z-20 shadow-none transition-all duration-300"
      ref={navbarRef}
      id="dashboard_navbar"
    >
      <div
        className="custom-container flex justify-between py-4 px-6 xl:px-10 items-center transition-all duration-500 ease-in-out"
        id="dashboard_navbar_container"
      >
        <h3 className="font-medium text-xl text-gray-800">{pageTitle}</h3>

        <div className="flex items-center gap-6">{children}</div>
      </div>
    </nav>
  );
}
